import { defineCatalogue } from '../../../i18n';
import { humanize } from './format';

export const publicationCatalogue = defineCatalogue(
  {
    'nav.post': 'Publicação',
    'select.label': 'Selecionar publicação',
    'select.title': 'Escolha uma publicação para ver',
    'select.search': 'Buscar pela legenda ou pela conta',
    'select.none': 'Nenhuma publicação encontrada',
    'post.missing.title': 'Publicação não encontrada',
    'post.missing.body': 'Ela não está na coleta da sua organização.',
    'post.authorAbsent': 'Conta sem identificação',
    'post.deleted': 'Apagada',
    'post.mediaAlt': 'Mídia da publicação',
    'post.untitled': 'Sem legenda',
    'post.excerpt': '“{text}”',
    'post.viewOn': 'Ver no {network}',
    'network.instagram': 'Instagram',
    'network.tiktok': 'TikTok',
    'kind.feed_image': 'Foto',
    'kind.story': 'Story',
    'kind.post': 'Post',
    'kind.reel': 'Reel',
    'story.title': 'Story de {handle}',
    'story.published': '{ago} · {date}',
    'story.onAir': 'No ar',
    'story.summary.one': 'Uma captura, em {time}',
    'story.summary.other': 'No ar por {duration} · {count} capturas',
    'story.timeline': 'Linha do tempo das 24 horas do story, de {from} a {to}: {count} capturas',
    'story.from': 'publicado',
    'story.to': 'expira',
    'sharedMedia.title': 'Também publicado por',
    'sharedMedia.empty': 'Nenhuma conta acompanhada publicou esta mídia.',
    'sharedMedia.open': 'Abrir a publicação de {name}',
    'sharedMedia.openSameAccount': 'Abrir a publicação de {name}, da mesma conta',
    'sharedMedia.sameAccount': 'mesma conta',
    'sharedMedia.sort.recent': 'Mais recentes',
    'sharedMedia.sort.reach': 'Maior alcance',
    'sharedMedia.sort.label': 'Ordenar por',

    'digest.title': 'Resumo do assistente',
    'digest.none': 'Ainda não há resumo desta publicação.',
    'digest.read.one': '{count} pessoa teve os comentários lidos',
    'digest.read.other': '{count} pessoas tiveram os comentários lidos',
    'digest.window': '{from} a {to}',
    'digest.ask': 'Perguntar sobre esta publicação',

    'metric.views': 'Visualizações',
    'metric.likes': 'Curtidas',
    'metric.comments': 'Comentários na plataforma',
    'metric.shares': 'Compartilhamentos',
    'metric.saves': 'Salvamentos',
    'metric.estimated_reach': 'Alcance estimado',
    'history.title': 'Métricas ao longo do tempo',
    'history.empty': 'Nenhuma métrica coletada para esta publicação nesta janela.',
    'history.chart': 'Métricas da publicação ao longo do tempo',
    'history.legend': 'Mostrar ou ocultar métricas',
    'history.rightAxis': '(eixo direito)',
    'post.related': 'Relacionada',
    'post.relatedAbout': 'a classificação',
    'post.relatedManual': 'Marcada manualmente',

    'figure.reach': 'Alcance',
    'figure.shareReach': 'Alcance de compartilhamentos',
    'figure.sentiment': 'Sentimento líquido',
    'figure.comments': 'Comentários analisados',
    'figure.versus': 'em relação à janela anterior',
    'figure.noScore': 'Sem leitura de sentimento nesta janela',
    'figure.failed': 'Não foi possível carregar',

    'terms.title': 'O que apareceu nos comentários',
    'terms.label': 'Termos dos comentários',
    'terms.empty': 'Nenhum termo nos comentários que a sua organização coletou.',

    'comments.title': 'O que os comentários dizem',
    'comments.list': 'Comentários',
    'comments.empty': 'A sua organização ainda não coletou comentários desta publicação.',
    'comments.more': 'Ver mais',
    'comments.all': 'Ver todos',
    'comments.bar': 'Posição dos comentários',
    'comments.authorAbsent': 'Pessoa sem nome',
    'count.supportive': 'Apoiam',
    'count.hostile': 'Criticam',
    'count.neutral': 'Neutros',
    'count.off_topic': 'Fora do assunto',

    'dimensions.title': 'Sentimento por dimensão',
    'dimensions.description': 'Quem comentou e a sua organização coletou.',
    'dimensions.about': 'estas dimensões',
    'dimensions.thin':
      'Poucos perfis diante de {n} comentários: este recorte ainda não representa o público.',
    'dimensions.notCollected': 'A sua organização ainda não coletou comentários desta publicação.',
    'dimensions.ageOnly':
      'Quem foi lido tem idade não identificada ou menor de 18, e por isso conta só na faixa etária.',
    'dimensions.allWithheld':
      'Os comentários que a sua organização coletou são poucos demais para mostrar algum grupo.',
    'dimension.age_band': 'Faixa etária',
    'dimension.gender_presentation': 'Gênero',
    'dimension.occupation': 'Ocupação',
    'dimension.education': 'Escolaridade',
    'dimensions.sample': 'Amostra',
    'dimensions.sampleAbout': 'a amostra',
    'chart.axis': 'Saldo de {min} a {max}',
    'chart.tip': 'Saldo {score}',
    'withheld.figure': 'Retido',
    'withheld.floor': 'Retido, no mínimo',
    'withheld.protects': 'Retido para não identificar quem comentou',
    'based.one': 'Baseado em {n} pessoa',
    'based.other': 'Baseado em {n} pessoas',
    'readings.one': '{count} leitura',
    'readings.other': '{count} leituras',

    'amp.title': 'Quem levou adiante',
    'amp.about': 'quem levou adiante',
    'amp.scope': 'Só as contas observadas na coleta da sua organização; não é o total.',
    'amp.empty': 'Nenhuma amplificação observada no que a sua organização coletou.',
    'amp.handleAbsent': 'Conta sem @',
    'amp.reach': 'Alcance de {name}',
    'amp.noReach': 'Sem alcance medido',
    'amp.map': 'Ver o caminho no mapa de influência',
  },
  {
    'nav.post': 'Post',
    'select.label': 'Select post',
    'select.title': 'Choose a post to view',
    'select.search': 'Search by caption or account',
    'select.none': 'No post found',
    'post.missing.title': 'Post not found',
    'post.missing.body': 'It is not in your organisation’s collection.',
    'post.authorAbsent': 'Unidentified account',
    'post.deleted': 'Deleted',
    'post.mediaAlt': 'Post media',
    'post.untitled': 'No caption',
    'post.excerpt': '“{text}”',
    'post.viewOn': 'View on {network}',
    'network.instagram': 'Instagram',
    'network.tiktok': 'TikTok',
    'kind.feed_image': 'Photo',
    'kind.story': 'Story',
    'kind.post': 'Post',
    'kind.reel': 'Reel',
    'story.title': 'Story by {handle}',
    'story.published': '{ago} · {date}',
    'story.onAir': 'On air',
    'story.summary.one': 'One capture, at {time}',
    'story.summary.other': 'On air for {duration} · {count} captures',
    'story.timeline': 'The story’s 24-hour timeline, {from} to {to}: {count} captures',
    'story.from': 'published',
    'story.to': 'expires',
    'sharedMedia.title': 'Also published by',
    'sharedMedia.empty': 'No tracked account has published this media.',
    'sharedMedia.open': 'Open {name}’s publication',
    'sharedMedia.openSameAccount': 'Open {name}’s publication, from the same account',
    'sharedMedia.sameAccount': 'same account',
    'sharedMedia.sort.recent': 'Most recent',
    'sharedMedia.sort.reach': 'Highest reach',
    'sharedMedia.sort.label': 'Sort by',

    'digest.title': 'Assistant summary',
    'digest.none': 'There is no summary of this post yet.',
    'digest.read.one': '{count} person had their comments read',
    'digest.read.other': '{count} people had their comments read',
    'digest.window': '{from} to {to}',
    'digest.ask': 'Ask about this post',

    'metric.views': 'Views',
    'metric.likes': 'Likes',
    'metric.comments': 'Comments on the platform',
    'metric.shares': 'Shares',
    'metric.saves': 'Saves',
    'metric.estimated_reach': 'Estimated reach',
    'history.title': 'Metrics over time',
    'history.empty': 'No metrics were collected for this post in this window.',
    'history.chart': 'The post’s metrics over time',
    'history.legend': 'Show or hide metrics',
    'history.rightAxis': '(right axis)',
    'post.related': 'Related',
    'post.relatedAbout': 'the classification',
    'post.relatedManual': 'Marked by hand',

    'figure.reach': 'Reach',
    'figure.shareReach': 'Reach through shares',
    'figure.sentiment': 'Net sentiment',
    'figure.comments': 'Comments analysed',
    'figure.versus': 'against the previous window',
    'figure.noScore': 'No sentiment reading in this window',
    'figure.failed': 'Could not load',

    'terms.title': 'What appeared in the comments',
    'terms.label': 'Comment terms',
    'terms.empty': 'No terms in the comments your organisation collected.',

    'comments.title': 'What the comments say',
    'comments.list': 'Comments',
    'comments.empty': 'Your organisation has not collected comments on this post yet.',
    'comments.more': 'Show more',
    'comments.all': 'See all',
    'comments.bar': 'Where the comments stand',
    'comments.authorAbsent': 'Unnamed person',
    'count.supportive': 'Supportive',
    'count.hostile': 'Critical',
    'count.neutral': 'Neutral',
    'count.off_topic': 'Off topic',

    'dimensions.title': 'Sentiment by dimension',
    'dimensions.description': 'Who commented, and your organisation collected.',
    'dimensions.about': 'these dimensions',
    'dimensions.thin':
      'Few profiles against {n} comments: this breakdown does not represent the audience yet.',
    'dimensions.ageOnly':
      'The people read have an unknown or under-18 age, so they count in the age band only.',
    'dimensions.notCollected':
      'Your organisation has not collected comments on this publication yet.',
    'dimensions.allWithheld':
      'The comments your organisation collected are too few to show any group.',
    'dimension.age_band': 'Age band',
    'dimension.gender_presentation': 'Gender',
    'dimension.occupation': 'Occupation',
    'dimension.education': 'Education',
    'dimensions.sample': 'Sample',
    'dimensions.sampleAbout': 'the sample',
    'chart.axis': 'Balance from {min} to {max}',
    'chart.tip': 'Balance {score}',
    'withheld.figure': 'Withheld',
    'withheld.floor': 'Withheld, at least',
    'withheld.protects': 'Withheld so commenters cannot be identified',
    'based.one': 'Based on {n} person',
    'based.other': 'Based on {n} people',
    'readings.one': '{count} reading',
    'readings.other': '{count} readings',

    'amp.title': 'Who carried it forward',
    'amp.about': 'who carried it forward',
    'amp.scope': 'Only accounts observed in your organisation’s collection; not the total.',
    'amp.empty': 'No amplification observed in what your organisation collected.',
    'amp.handleAbsent': 'Account without a handle',
    'amp.reach': 'Reach of {name}',
    'amp.noReach': 'No reach measured',
    'amp.map': 'See the path on the influence map',
  },
);

export const pub = publicationCatalogue.t;
export const pubPlural = publicationCatalogue.plural;

const NETWORK_KEYS: Record<string, 'network.instagram' | 'network.tiktok'> = {
  instagram: 'network.instagram',
  tiktok: 'network.tiktok',
};

const KIND_KEYS: Record<string, 'kind.feed_image' | 'kind.story' | 'kind.post' | 'kind.reel'> = {
  feed_image: 'kind.feed_image',
  story: 'kind.story',
  POST: 'kind.post',
  REEL: 'kind.reel',
  STORY: 'kind.story',
};

/** The post's network, named rather than shown as the wire's platform token. */
export function networkLabel(platform: string): string {
  const key = NETWORK_KEYS[platform];
  return key !== undefined ? pub(key) : humanize(platform);
}

/** The post's content kind, named rather than shown as the wire's kind token. */
export function kindLabel(kind: string): string {
  const key = KIND_KEYS[kind];
  return key !== undefined ? pub(key) : humanize(kind);
}
